<template>

      <v-btn
        primary dark
        :disabled="loading"
        large
        @click="login"
      >
        <span v-if="loading">Logging in...</span>
        <span v-if="!loading">Login with Ethereum</span>
      </v-btn>

</template>

<script>
import { config } from '@/config'

export default {
  data: () => ({
    loading: false
  }),
  methods: {
    async login() {
      this.loading = true

      const addresses = await window.ethereum.enable()
      const myAddress = addresses[0]
      console.log('myAddress: ' + myAddress)
      // const myProfile = await window.Box.getProfile(myAddress)
      // console.log(myProfile)

      const box = await window.Box.openBox(myAddress, window.ethereum, {})
      const appSpace = await box.openSpace(config.spaceName.app)
      // const NFTCommentsSpace = await box.openSpace(config.spaceName.NFTComments)
      // console.log(appSpace)
      const myDid = appSpace.DID
      await new Promise((resolve, reject) => box.onSyncDone(resolve))

      const userProfile = await box.public.all()
      if (Object.entries(userProfile).length === 0) {
         this.$router.push({ name: 'register' })
      }
      else {
        // Add default following List
        const followingKey = config.usrKeys.following
        const followingList = []
        const followingListStr = JSON.stringify(followingList)
        if (!(followingKey in userProfile)) {
          console.log('setting following list')
          await box.public.set(followingKey, followingListStr)
        }
        this.$store.state.box = box
        this.$store.state.myAddress = myAddress
        this.$store.state.appSpace = appSpace
        this.$store.state.myDid = myDid
        localStorage.setItem(config.localStorageKey.login, myAddress)
        if (this.$route.query && this.$route.query.redirect) {
          this.$router.push({ path: this.$route.query.redirect})
        }
        else {
          this.$router.push({ name: config.defaultRedirect.appHome })
        }
      }


    }

  }
}
</script>
